/**
 *
 * RecommendationTaskResumen
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Dropdown, Menu } from "antd"
import pointMenu from "images/three-points-gray.svg"
import checkIcon from "images/check.svg"
import fullCheckIcon from "images/full-check.svg"
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
class RecommendationTaskResumen extends React.Component {
  state = {
    isOpen: true,
    periodicity: [
      "No se repite",
      "Semanal",
      "Quincenal",
      "Mensual",
      "Trimestral",
      "Semestral",
      "Anual",
    ],
  }

  render() {
    const { data, onEdit, onDelete } = this.props

    return (
      <div className="RecommendationTaskResumen-component">
        <div
          className="RecommendationTaskResumen-component-row"
          style={{ gridTemplateColumns: "30px auto 200px" }}>
          <div>
            <img
              src={data.done ? fullCheckIcon : checkIcon}
              style={{ width: 20 }}
            />
          </div>
          <div>
            <span>{data.name}</span>
          </div>
          <div className="RecommendationTaskResumen-component-options">
            <Dropdown
              trigger={["click"]}
              placement="bottomRight"
              overlay={
                <Menu>
                  <Menu.Item onClick={() => onEdit(data)}>Editar</Menu.Item>
                  <Menu.Item onClick={() => onDelete(data)}>Eliminar</Menu.Item>
                </Menu>
              }>
              <img style={{ cursor: "pointer", padding: 5 }} src={pointMenu} />
            </Dropdown>
          </div>
        </div>
      </div>
    )
  }
}

RecommendationTaskResumen.propTypes = {}

export default RecommendationTaskResumen
